import { render, staticRenderFns } from "./PendienteVsDespachado.vue?vue&type=template&id=fed9ebbe&scoped=true&"
import script from "./PendienteVsDespachado.vue?vue&type=script&lang=js&"
export * from "./PendienteVsDespachado.vue?vue&type=script&lang=js&"
import style0 from "./PendienteVsDespachado.vue?vue&type=style&index=0&id=fed9ebbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed9ebbe",
  null
  
)

export default component.exports